import React from 'react';
import {Content, Container, DataContainer} from 'app/components/matchEvents/MatchEventStyles';
import {COLORS, IconBadge, Image, Typography} from '@fupa/fupa-uikit';
import {ArrowDown, ArrowUp} from 'app/components/icons';
import MatchEventMinute from 'app/components/matchEvents/MatchEventMinute';
import {FlexContainer} from 'app/styles/content';
import {Person} from '@mui/icons-material';

const IMAGE_SIZE = 56;
const MatchEventSubstitution = ({event}) => {
  let subIn =
    event.primaryRole && event.primaryRole.player
      ? `${event.primaryRole.player.firstName} ${event.primaryRole.player.lastName}`
      : 'Unbekannter Spieler';
  let subOut =
    event.secondaryRole && event.secondaryRole.player
      ? `${event.secondaryRole.player.firstName} ${event.secondaryRole.player.lastName}`
      : 'unbekannten Spieler';
  const substitution = `${subIn} für ${subOut}`;
  const standingMessage = `Wechsel 🔄 bei ${event.team?.name?.middle ?? 'nicht angegebenem Team'}`;
  const time = event.additionalMinute > 0 ? `${event.minute}'+${event.additionalMinute}` : `${event.minute}'`;
  const iconIn = () => <ArrowUp style={{color: COLORS.green, fontSize: 12}} />;
  const iconOut = () => <ArrowDown style={{color: COLORS.red, fontSize: 12}} />;
  const fallbackPlayerImage = (
    <Person
      style={{background: COLORS.lightestGrey, borderRadius: '100%', color: COLORS.lightGrey, fontSize: IMAGE_SIZE}}
    />
  );

  const playerImageIn = event.primaryRole?.player?.image ? (
    <Image
      entity='player'
      src={event.primaryRole.player.image}
      ratio='1:1'
      width={IMAGE_SIZE}
      height={IMAGE_SIZE}
      circle={true}
    />
  ) : (
    fallbackPlayerImage
  );
  const playerImageOut = event.secondaryRole?.player?.image ? (
    <Image
      entity='player'
      src={event.secondaryRole.player.image}
      ratio='1:1'
      width={IMAGE_SIZE}
      height={IMAGE_SIZE}
      circle={true}
    />
  ) : (
    fallbackPlayerImage
  );
  return (
    <Content>
      <Container>
        <MatchEventMinute minute={time} />
        <DataContainer>
          <FlexContainer style={{gap: '0.75rem'}}>
            <FlexContainer style={{gap: '0.5rem'}}>
              <div style={{position: 'relative'}}>
                <IconBadge value={iconIn()} position={2} />
                {playerImageIn}
              </div>
              <div style={{position: 'relative'}}>
                <IconBadge value={iconOut()} position={3} />
                {playerImageOut}
              </div>
            </FlexContainer>
            <FlexContainer style={{flexDirection: 'column'}}>
              <Typography variant='body1'>{standingMessage}</Typography>
              <Typography variant='body2'>{substitution}</Typography>
            </FlexContainer>
          </FlexContainer>
        </DataContainer>
      </Container>
    </Content>
  );
};

export default MatchEventSubstitution;
